import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@rocketlane/ui';
import { forwardRef } from 'react';
// antd "tertiary" maps to the secondary variant in @rocketlane/ui.
export const TertiaryButton = /*#__PURE__*/ forwardRef((props, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ _jsx(Button, {
        ref: ref,
        variant: "secondary",
        type: "button",
        ...props
    }));
TertiaryButton.displayName = 'TertiaryButton';
